import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
}
export const fetchAllAuthentication = createAsyncThunk(
    "fetchAllAuthentication",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/fraction/purchase-property/fetch-all-purchased-property?page=${body.page}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const AuthenticationSlice = createSlice({
    name: 'AuthenticationSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllAuthentication.pending, (state, action) => { 
            state.loading = true;
        })
        builder.addCase(fetchAllAuthentication.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        })
        builder.addCase(fetchAllAuthentication.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        // builder.addCase(fetchSinglePurchasedProperty.pending, (state, action) => {
        //     state.loading = true;
        //     state.singlePurPro = null;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.singlePurPro = action.payload;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload?.data;
        // });

    },

})

export default AuthenticationSlice.reducer;